import '../styles/home.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGooglePlay, faTiktok, faInstagram, faYoutube, faGithub } from '@fortawesome/free-brands-svg-icons'
import { faArrowDown, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import googlePlayLogo from '../imgs/google_paly_logo.png'
import { Fade } from 'react-awesome-reveal'
import flashLogo from "../imgs/flashapp_logo.png"
import flashScreen1 from "../imgs/flashapp_1.png"
import flashScreen2 from "../imgs/flashapp_2.png"
import prankLogo from "../imgs/prankapp_logo.png"
import prankScreen1 from "../imgs/prankapp_1.png"
import prankScreen2 from "../imgs/prankaoo_2.png"
import trackpadLogo from "../imgs/mouse_logo.png"
import mousePad1 from "../imgs/mouse_1.png"
import mousePad2 from "../imgs/mouse_2.png"

export default function Home() {
    return (
        <main className="home">
            <div className="home-orb home-orb--1" />
            <div className="home-orb home-orb--2" />
            <div className="home-grid-bg" />

            {/* ====== HERO ====== */}
            <section className="home-hero">
                <div className="hero-badge">Android App Studio</div>
                <h1 className="hero-title">
                    We craft apps<br />
                    <span className="hero-title--accent">people love.</span>
                </h1>
                <p className="hero-subtitle">
                    From playful pranks to powerful utilities — we ship creative
                    Android experiences used by thousands.
                </p>
                <div className="hero-actions">
                    <a
                        className="btn-main"
                        href='https://play.google.com/store/apps/dev?id=6256207236238699098'
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FontAwesomeIcon icon={faGooglePlay} />
                        <span>View on Google Play</span>
                    </a>
                    <a className="btn-ghost" href="#apps">
                        <span>See our work</span>
                        <FontAwesomeIcon icon={faArrowDown} />
                    </a>
                </div>

                <div className="hero-socials">
                    <a className="social--tiktok" href="https://www.tiktok.com/@eosrmg" target="_blank" rel="noopener noreferrer" aria-label="TikTok"><FontAwesomeIcon icon={faTiktok} /></a>
                    <a className="social--instagram" href="https://www.instagram.com/eosrmg_developer/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FontAwesomeIcon icon={faInstagram} /></a>
                    <a className="social--youtube" href="https://www.youtube.com/channel/UCUzEYts1gAURebNLCcEtHoA" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><FontAwesomeIcon icon={faYoutube} /></a>
                    <a className="social--github" href="https://github.com/eosrmg" target="_blank" rel="noopener noreferrer" aria-label="GitHub"><FontAwesomeIcon icon={faGithub} /></a>
                </div>

                <div className="scroll-hint">
                    <div className="scroll-mouse">
                        <div className="scroll-wheel" />
                    </div>
                </div>
            </section>

            {/* ====== APP SHOWCASES ====== */}
            <section className="showcases" id="apps">



                                {/* --- BT Trackpad --- */}
                <div className="showcase showcase--gray showcase--violet">
                    <div className="showcase__glow showcase__glow--violet" />

                    <div className="showcase__content">
                        <Fade direction="up" triggerOnce cascade damping={0.08}>
                            <div className="showcase__badge showcase__badge--violet">Featured App</div>
                            <div className="showcase__header">
                                <img src={trackpadLogo} alt="BT Trackpad icon" className="showcase__logo" />
                                <div>
                                    <h2 className="showcase__title">BT Trackpad</h2>
                                    <p className="showcase__tagline">Transform your Android phone into a powerful wireless Bluetooth mouse</p>
                                </div>
                            </div>
                            <p className="showcase__desc">
                                Turn your Android phone into a wireless Bluetooth mouse or touchpad with smooth
                                cursor control, scrolling, gestures, and quick clicks for laptops and desktops.
                            </p>
                            <div className="showcase__chips">
                                <span className="chip chip--violet">Bluetooth Mouse</span>
                                <span className="chip chip--violet">Touchpad Gestures</span>
                                <span className="chip chip--violet">Scroll & Zoom</span>
                                <span className="chip chip--violet">Left / Right Click</span>
                                <span className="chip chip--violet">Precision Cursor</span>
                            </div>
                            <a
                                className="showcase__cta showcase__cta--violet"
                                href='https://play.google.com/store/apps/details?id=com.eosrmg.apps.mousekeys'
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FontAwesomeIcon icon={faGooglePlay} />
                                <span>Get it on Google Play</span>
                            </a>
                        </Fade>
                    </div>

                    <Fade direction="right" triggerOnce>
                        <div className="showcase__phones">
                            <div className="phone phone--back">
                                <img src={mousePad2} alt="Trackpad settings" />
                            </div>
                            <div className="phone phone--front">
                                <img src={mousePad1} alt="Trackpad main screen" />
                            </div>
                        </div>
                    </Fade>
                </div>

                

                {/* --- LightPulse --- */}
                <div className="showcase showcase--cyan">
                    <div className="showcase__glow showcase__glow--cyan" />

                    <div className="showcase__content">
                        <Fade direction="up" triggerOnce cascade damping={0.08}>
                            <div className="showcase__badge">Featured App</div>
                            <div className="showcase__header">
                                <img src={flashLogo} alt="LightPulse icon" className="showcase__logo" />
                                <div>
                                    <h2 className="showcase__title">LED Flash Alerts</h2>
                                    <p className="showcase__tagline">Flash alerts for calls, SMS & notifications</p>
                                </div>
                            </div>
                            <p className="showcase__desc">
                                Customize every flash notification on your device — choose from multiple
                                flash styles, set up smart schedules, and save battery with intelligent controls.
                            </p>
                            <div className="showcase__chips">
                                <span className="chip chip--cyan">Flash Styles</span>
                                <span className="chip chip--cyan">Call & SMS</span>
                                <span className="chip chip--cyan">Strobe & Screen Light</span>
                                <span className="chip chip--cyan">Battery Saver</span>
                                <span className="chip chip--cyan">Do Not Disturb</span>
                                <span className="chip chip--cyan">Silent / Vibrate / Ring</span>
                            </div>
                            <a
                                className="showcase__cta"
                                href='https://play.google.com/store/apps/details?id=com.bianca.apps.flashlight.call.notification.alert'
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FontAwesomeIcon icon={faGooglePlay} />
                                <span>Get it on Google Play</span>
                            </a>
                        </Fade>
                    </div>

                    <Fade direction="right" triggerOnce>
                        <div className="showcase__phones">
                            <div className="phone phone--back">
                                <img src={flashScreen2} alt="LightPulse settings" />
                            </div>
                            <div className="phone phone--front">
                                <img src={flashScreen1} alt="LightPulse main screen" />
                            </div>
                        </div>
                    </Fade>
                </div>

                {/* --- Broken Screen Prank --- */}
                <div className="showcase showcase--green showcase--reverse">
                    <div className="showcase__glow showcase__glow--green" />

                    <Fade direction="right" triggerOnce>
                        <div className="showcase__phones">
                            <div className="phone phone--back">
                                <img src={prankScreen2} alt="Broken Screen Prank effects gallery" />
                            </div>
                            <div className="phone phone--front">
                                <img src={prankScreen1} alt="Broken Screen Prank main screen" />
                            </div>
                        </div>
                    </Fade>

                    <div className="showcase__content">
                        <Fade direction="up" triggerOnce cascade damping={0.08}>
                            <div className="showcase__badge showcase__badge--green">Fun & Prank</div>
                            <div className="showcase__header">
                                <img src={prankLogo} alt="Broken Screen Prank icon" className="showcase__logo" />
                                <div>
                                    <h2 className="showcase__title">Broken Screen Prank</h2>
                                    <p className="showcase__tagline">Realistic cracked screen effects</p>
                                </div>
                            </div>
                            <p className="showcase__desc">
                                Fool your friends with ultra-realistic broken screen overlays.
                                Choose from multiple crack styles — hairline cracks, line of death,
                                burn-in ghost images, and more.
                            </p>
                            <div className="showcase__chips">
                                <span className="chip chip--green">8+ Effects</span>
                                <span className="chip chip--green">One-Tap Activate</span>
                                <span className="chip chip--green">Hairline Crack</span>
                                <span className="chip chip--green">Burn-In Ghost</span>
                                <span className="chip chip--green">Line of Death</span>
                                <span className="chip chip--green">Multiple Lines</span>
                            </div>
                            <a
                                className="showcase__cta showcase__cta--green"
                                href='https://play.google.com/store/apps/details?id=com.bianca.apps.brokenscreenprank'
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FontAwesomeIcon icon={faGooglePlay} />
                                <span>Get it on Google Play</span>
                            </a>
                        </Fade>
                    </div>
                </div>

            </section>

        </main>
    );
}
